export enum CampaignRouteEnum {
  MAIN = "campaign.main",
  MAIN_SMS = "campaign.main-sms",
  MAIN_WHATSAPP = "campaign.main-whatsapp",
  MAIN_EMAIL = "campaign.main-email",
}
